
import { mapState, mapActions } from "vuex";
import BackButtonWithBlankLogo from "../common/back-botton-with-blank-logo.vue";
import CountrycodeWithTextfield from "../common/countrycode-with-textfield.vue";

export default {
  components: { BackButtonWithBlankLogo, CountrycodeWithTextfield },
  name: "userLogin",
  data() {
    return {
      resetData: {},
      otpWithPhoneNo: true,
      valid: false,
      loading: false,
      formError: "",
      isPhoneValid: false
    };
  },
  props: {
    tab: {
      type: Number,
      default: 0
    },
    resetDataProp: {}
  },

  mounted() {
    this.resetData = JSON.parse(JSON.stringify(this.resetDataProp));
    this.$refs.form.resetValidation();
  },
  watch: {
    otpWithPhoneNo(val) {
      if (val) {
        this.resetData.mobile.country_code = "+91";
        this.resetData.email = "";
      } else {
        this.resetData.mobile.number = "";
      }
    }
  },
  computed: {
    isFormValid() {
      return this.valid && (this.tab === 0 ? this.isPhoneValid : true);
    }
  },
  methods: {
    ...mapActions("auth", ["requestForgotPasswordpOtp"]),

    sendOtp() {
      if (this.isFormValid) {
        this.loading = true;
        let payload = {};
        if (this.tab === 0) {
          payload = {
            mobile_number: `${this.resetData.mobile.country_code}${this.resetData.mobile.number}`
          };
        } else {
          payload = { email: `${this.resetData.email}` };
        }
        this.requestForgotPasswordpOtp(payload)
          .then((response) => {
            if (response.data.status === "success") {
              this.$nuxt.$emit("show-toast", {
                text: response.data.message,
                color: "success darken-2",
                icon: "done",
                flat: true
              });
              this.resetData.otpRequest = payload;
              this.resetData.otpResponse = response.data;
              this.$emit("otp-sent", this.resetData);
            } else {
              this.$nuxt.$emit("show-error-toast", response);
            }
          })
          .catch((errr) => {
            this.$nuxt.$emit("show-error-toast", errr);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
